import jsPDF from "jspdf";
import { vatRateOnDate, vatRateAddOnDate, vatRateStringOnDate } from '@/utils';
import { DateTime } from "luxon";
import fonts from "../../assets/fonts/fonts.js";
import images from "../../assets/oferta_images.js";
import router from "../../router/index.js";
// import { formatPhoneNo } from '@/utils';
import { languages } from "@/translations/productie/proforma/lang_proforma.js"


export const pdf_proforma_productie = {
  createProformaProductiePDF(proforma) {
    return new Promise(resolve => {
      try {
		const lang = languages[proforma.country];
		
        const doc = new jsPDF({
          orientation: "p",
          unit: "mm",
          format: "a4"
        });
        const logo = proforma.country == 'ro' ? images.data.logo_istruct_cuprolli : images.data.logo_istruct

        //add the font to jsPDF
        doc.addFileToVFS("Roboto-Regular.ttf", fonts.robotoRegular);
        doc.addFileToVFS("Roboto-Bold.ttf", fonts.robotoBold);
        doc.addFont("Roboto-Regular.ttf", "Roboto", "normal");
        doc.addFont("Roboto-Bold.ttf", "Roboto", "bold");

        // set font
        doc.setFont("Roboto", "normal");
        doc.setTextColor(100);

		const logoDim = proforma.country == 'ro' ? [9,11] : [11,6];

        // Add Logo
		doc.addImage(logo, "JPEG", 10, logoDim[0], 50, logoDim[1]);

        // Header - Left side
        doc.setFont("Roboto", "bold");
        doc.setFontSize(10);
        doc.text(lang.header.company, 10, 30);
        doc.setFontSize(9);
        doc.setFont("Roboto", "normal");
        doc.text([`${lang.labels.vatId}: ${lang.header.vatId}`,`${lang.labels.regCom}: ${lang.header.regCom}`], 10, 35, {
          lineHeightFactor: 1.25,
        });
        doc.text(
          [lang.header.address1, lang.header.address2],
          10,
          43
        );
        // doc.text("Dumbravita, str. Tarcului nr. 7 ap. 5, jud. Timis", 10, 43);
        doc.setFont("Roboto", "bold");
        doc.text(
          [`${lang.labels.bank}: ${lang.header.bankName}`, `${lang.labels.iban}: ${lang.header.ibanNo}`],
          10,
          53
        );
		let space = 62;
		if (lang.labels.iban2 && lang.header.ibanNo2) {
			doc.text(
			[`${lang.labels.bank}: ${lang.header.bankName}`, `${lang.labels.iban2}: ${lang.header.ibanNo2}`],
			10,
			space
			);
			space += 10;
		}
		
        doc.setFont("Roboto", "normal");

		const userEmail = proforma.country == 'ro' ? proforma.email_user : 'export@i-struct.eu'
		const userTel = proforma.country == 'ro' ? proforma.tel_user : '+43 681 20265171'

        doc.text(
          [
			`${lang.labels.mrMrs}: ${proforma.username}`,
			`${lang.labels.email}: ${userEmail}`,
			`${lang.labels.phone}: ${userTel}`
          ],
          10,
          space,
          {
            lineHeightFactor: 1.35,
          }
        );
        doc.setFont("Roboto", "bold");
        const vatText = +proforma.is_vat_free ? lang.labels.vatFree : `${lang.labels.vatRate}: ${vatRateStringOnDate(proforma.data)}`;
        doc.text(vatText, 10, space + 16);
        doc.setFont("Roboto", "normal");

		space += 26;

        //
		// Header - Right side
		// let data = moment(String(proforma.data)).format("DD.MM.YYYY");
		const date = DateTime.fromISO(proforma.data).toFormat(lang.dateFormat);
		doc.setFontSize(16);
		// doc.setTextColor(243, 153, 46);
		doc.setTextColor(160, 171, 192);
		doc.text(lang.labels.proforma, 130, 15);
		doc.setFontSize(9);
		doc.setTextColor(100);
		doc.text(`${lang.labels.no}.` + proforma.id_proforma + " / " + date, 130, 20);

		// Client data
		doc.setFont("Roboto", "bold");
		doc.setFontSize(10);
		doc.text(lang.labels.client, 130, 30);
		doc.setFontSize(9);
		doc.setFont("Roboto", "normal");
		let name = proforma.nume;
		let drop = 35;
		let nameSplit = doc.splitTextToSize(name, 62);
		doc.text(nameSplit, 130, drop, {
			lineHeightFactor: 1.35,
		});
		if (name.length <= 44) {
			drop = drop + 5;
		} else {
			drop = drop + 9;
		}

		if (proforma.cui) {
			doc.text(`${lang.labels.vatId}:` + proforma.cui, 130, drop);
			drop = drop + 4;
		}

		if (proforma.adresa) {
			let adresa = proforma.adresa;
			if (proforma.oras) {
				adresa += ", " + proforma.oras;
			}
			let adresaSplit = doc.splitTextToSize(adresa, 62);
			doc.text(adresaSplit, 130, drop);
			if (adresa.length != 0 && adresa.length <= 44) {
				drop = drop + 4;
			} else if (adresa.length != 0 && adresa.length <= 73) {
				drop = drop + 8;
			} else if (adresa.length != 0) {
				drop = drop + 12;
			}
		}

		drop = drop + 1;

      	let details = [];
		if (proforma.persoana) {
			details.push(`${lang.labels.mrMrs}: ${proforma.persoana}`);
		}
		if (proforma.email) {
			details.push(`${lang.labels.email}: ${proforma.email}`);
		}
		if (proforma.tel != "-") {
			details.push(`${lang.labels.phone}: ${proforma.tel}`);
		}
		doc.text(details, 130, drop, {
			lineHeightFactor: 1.35,
		});

      doc.setFont("Roboto", "bold");
			doc.setFontSize(10);
			doc.text(`${lang.labels.proformaValidity}: ${lang.header.validDays} ${lang.labels.days}`, 130, drop + 20)
			doc.setFont("Roboto", "normal");
			doc.setFontSize(10);

			// Table header
			doc.setFont("Roboto", "bold");
			doc.text(`${lang.labels.no}.`, 10, space);
			doc.text(lang.labels.productName, 18, space);
			doc.text(lang.labels.qty, 128, space);
			doc.text(lang.labels.onePrice, 152, space);
			doc.text([lang.labels.netAmount, `(${lang.labels.woVat})`], 189, space - 4, {align: "center"});
			doc.setDrawColor(150);
			doc.setLineWidth(0.4);
			doc.line(10, space + 2, 200, space + 2);
			space += 7;
			doc.setFont("Roboto", "normal");

			doc.text("1", 11, space);
			const oferta_data = DateTime.fromISO(proforma.oferta_data).toFormat(lang.dateFormat);

			if (proforma.country == 'hu') {
				doc.text(
				[
					proforma.denumire_produs,
					`${proforma.procent_proforma}% ${lang.labels.downPayment}, ${lang.labels.accordingToOfferNo} ${proforma.oferta_id}, ${oferta_data} ${lang.labels.from} `,
				],
				18,
				space,
				{ lineHeightFactor: 1.5 }
				);
			} else {
				doc.text(
					[
						proforma.denumire_produs,
						`${proforma.procent_proforma}% ${lang.labels.downPayment}, ${lang.labels.accordingToOfferNo} ${proforma.oferta_id} ${lang.labels.from} ${oferta_data}`,
					],
					18,
					space,
					{ lineHeightFactor: 1.5 }
				);
			}
			doc.text(`${proforma.buc_lucrare} ${lang.labels.piece}`, 134, space, {
				align: "center",
			});

      let pret_unitar = +proforma.is_vat_free ? Number(proforma.suma_proforma) : (proforma.suma_proforma / vatRateAddOnDate(proforma.data));
			let valoare = pret_unitar * proforma.buc_lucrare;
			doc.text(pret_unitar.toFixed(2) + ' ' +  proforma.moneda, 170, space, { align: "right" });
			doc.text(valoare.toFixed(2) + ' ' + proforma.moneda, 199, space, { align: "right" });

			doc.line(10, space + 8, 200, space + 8);
			space = space + 12;

      doc.setFont("Roboto", "bold");

      let val_avans = +proforma.is_vat_free ? Number(proforma.suma_proforma) : (proforma.suma_proforma / vatRateAddOnDate(proforma.data));
			doc.text(`${lang.labels.subtotal} (${lang.labels.woVat})`, 170, space + 2, {
        align: "right",
      });
	  doc.text(val_avans.toFixed(2) + ' ' + proforma.moneda, 199, space + 2, {
			align: "right",
	  });
	  doc.text(lang.labels.vat, 170, space + 7, {
        align: "right",
      });
      const vat = +proforma.is_vat_free ? 0 : vatRateOnDate(proforma.data);
			let tva_avans = val_avans * vat;
			doc.text(tva_avans.toFixed(2) + ' ' + proforma.moneda, 199, space + 7, {
				align: "right",
			});
	  doc.text(lang.labels.total, 170, space + 12, {
        align: "right",
      });
	  let total_avans = Number(val_avans) + Number(tva_avans);
	  doc.text(total_avans.toFixed(2) + ' ' + proforma.moneda, 199, space + 12, {
		align: "right",
	  });
	  doc.line(10, space + 16, 200, space + 16);
      if (+proforma.is_vat_free) {
        doc.setFont("Roboto", "normal");
        doc.text([lang.labels.note1, lang.labels.note2], 199, space + 20, {
          align: "right",
        });
      }

	  space += 22
	  
	  if (proforma.country == 'hu' && proforma.curs_huf) {
		const curs_huf = parseFloat(proforma.curs_huf.replace(',', '.'));
		const total_huf = (total_avans * curs_huf).toFixed(0);
		doc.setFont("Roboto", "bold");
		doc.text(`${lang.labels.total} (HUF)`, 170, space, {
         align: "right",
        });
		doc.text(`${total_huf} HUF`, 199, space, {
			align: "right",
		});
	  }

        // Return document
        resolve(doc)
      }
      catch(err) {
        console.error(err)
        router.push({
          query: M.toast({
            html: "Eroare la generare pdf!",
            classes: "red",
          }),
        });
      }
    });
  }
};